/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.ai.rpc.FeedbackService
 */

export const recordFeedbackRpc = {
  serviceName: 'com.hubspot.commerce.ai.rpc.FeedbackService',
  rpcName: 'recordFeedback',
  auth: 'app',
  fingerprint: 'jbeyoS72a6Ka8f_Yopx0xivQBLUs6hhy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};